<ng-container *ngIf="!loading">
  <div class="header" *ngIf="tournament && !hiddenHeader">
    <div class="title">
      <a [routerLink]="tournamentRoute" class="name">{{ tournament.name }}</a>
      <a [routerLink]="tournamentRoute" class="btn-detail">Перейти</a>
    </div>
  </div>
  <div class="stage-content" *ngIf="teams">
    <mtg-table>
      <mtg-table-header-row mtgSticky="top">
        <mtg-table-identity-col>
          <div class="table-title">Команды</div>
        </mtg-table-identity-col>
        <mtg-table-col>Очки</mtg-table-col>
        <mtg-table-col-group
          *ngFor="let stage of stages"
          [title]="stage.name"
        >
          <mtg-table-col>Место</mtg-table-col>
          <mtg-table-col>Очки</mtg-table-col>
        </mtg-table-col-group>
      </mtg-table-header-row>
      <mtg-table-row *ngFor="let team of teams; let i = index;">
        <mtg-table-identity-col>
          <div class="number">{{ i + 1 }}</div>
          <div class="photo">
            <a [routerLink]="getTeamRoute(team.team.id)">
              <img [src]="team.logo.path" *ngIf="team.logo.path">
              <div [ngClass]="team.team.getEmptyLogoClass()" *ngIf="!team.logo.path"></div>
            </a>
          </div>
          <div class="info">
            <a [routerLink]="getTeamRoute(team.team.id)">
              <div class="name">{{ team.name }}</div>
            </a>
          </div>
        </mtg-table-identity-col>
        <mtg-table-col>{{ team.points || 0 }}</mtg-table-col>
        <mtg-table-col-group *ngFor="let stage of stages;">
          <mtg-table-col>{{ getStageTeam(team.id, stage.id).finalStanding || '-' }}</mtg-table-col>
          <mtg-table-col>{{ getStageTeam(team.id, stage.id).receivedPoints || '-' }}</mtg-table-col>
        </mtg-table-col-group>
      </mtg-table-row>
    </mtg-table>
  </div>
  <div class="loading" *ngIf="!teams">
    <mtg-spinner></mtg-spinner>
  </div>
</ng-container>

<div class="loading" *ngIf="loading">
  <mtg-spinner></mtg-spinner>
</div>
